import React from "react";
import { Confirm } from "semantic-ui-react";
import "../CsaMedia/CsaMedia.css";

const ConfirmPaymentModal = (props) => {
  return (
    <>
      <Confirm
        open={props.open}
        className="confirm-delete-popup initiate-modal"
        content={
          <div className="content">
            <div className="initiate-modal-content-1">
              Are you sure want to initiate payment ?
            </div>
            <div className="initiate-modal-content-2">
              This process cannot be undone.
            </div>
          </div>
        }
        onCancel={() => {
          props.close();
        }}
        onConfirm={props.confirm}
        cancelButton="Cancel"
        confirmButton="Payment"
      />
    </>
  );
};

export default ConfirmPaymentModal;
